import React from 'react'
import { Col, Row } from 'styled-bootstrap-grid'
import { Input } from 'antd'

import { useDispatch, useSelector } from 'react-redux'
import { CenteredRow, Label } from '../../../components/Page/Layout'
import { selectedTheme, isValidating, getThemeValidationResult } from '../../../features/theme/selectors'
import { ThemeActions } from '../../../features/theme/actions'
import { LoadingOverlay } from '../../../components/Loading/LoadingOverlay'
import { WizardNav, NavProps, WizardNavigationWrapper } from '../../../components/Wizard/WizardNav'

type Props = {
  close?: () => void
} & NavProps

export const AddThemeName = ({ close, ...rest }: Props) => {
  const dispatch = useDispatch()
  const theme = useSelector(selectedTheme)
  const status = useSelector(getThemeValidationResult)
  const loading = useSelector(isValidating)

  const changeHandler = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const themeToValidate = { ...theme, name: e.target.value }
    await dispatch(ThemeActions.updateNewTheme(themeToValidate))
    if (themeToValidate.name && themeToValidate.name.length > 2) {
      await dispatch(ThemeActions.startThemeValidation(themeToValidate))
    }
  }

  return (
    <LoadingOverlay loading={loading}>
      <div className="mt40">
        <CenteredRow>Inserisci Nome</CenteredRow>
        <Row>
          <Col md={8} mdOffset={2} xs={12} xsOffset={0}>
            <Label>nome del tema</Label>
            <Input placeholder="nome" onChange={changeHandler} value={theme?.name} />
            <span className="error-input">{status && status.message}</span>
          </Col>
        </Row>
        <WizardNavigationWrapper>
          <WizardNav {...rest} previousStep={close} nextDisabled={!status?.isValid} />
        </WizardNavigationWrapper>
      </div>
    </LoadingOverlay>
  )
}
